import transactionSourceIcons from 'assets/svg/transactionSourceIcons'
import { FilledPendingIcon } from 'assets/svg/svgs'
import { TransactionKind } from 'storeTypes'
import { TransactionKindConfigType } from '../types'
import { colors } from 'styles/colors'

const {
    PaymentSuccessIcon,
    AwardCreditIcon,
    TruckDeliveryIcon,
    PaymentCorrectionIcon,
    ReimbursementCoinsIcon
} = transactionSourceIcons

export const getTransactionTypeSettings = (
    type: TransactionKind,
    amountColor: string
) => {
    const isPotentialClient = amountColor === 'amount-potential'
    const colorToUse = isPotentialClient ? colors.maroon : ''
    const transactionTypeSettings: TransactionKindConfigType = {
        [TransactionKind.MOBILE_MONEY_PAYMENT]: {
            icon: PaymentSuccessIcon({
                color: colorToUse
            }),
            labelText: 'payment-success-icon',
            amountColor
        },
        [TransactionKind.MOBILE_MONEY_PAYMENT_REVERSAL]: {
            icon: PaymentCorrectionIcon({ color: colorToUse || colors.brown }),
            labelText: 'momo-reversal-icon',
            amountColor
        },
        [TransactionKind.VOUCHER_PAYMENT]: {
            icon: PaymentSuccessIcon({
                color: colorToUse
            }),
            labelText: 'payment-success-icon',
            amountColor
        },
        [TransactionKind.PENDING]: {
            icon: FilledPendingIcon({}),
            labelText: 'payment-pending-icon'
        },
        [TransactionKind.AWARD]: {
            icon: AwardCreditIcon({ color: colorToUse }),
            labelText: 'award-icon',
            amountColor
        },
        [TransactionKind.AWARD_REVERSAL]: {
            icon: AwardCreditIcon({ color: colorToUse || colors.brown }),
            labelText: 'award-reversal-icon',
            amountColor
        },
        [TransactionKind.DELIVERY]: {
            icon: TruckDeliveryIcon({}),
            labelText: 'delivery-payment-icon',
            amountColor
        },
        [TransactionKind.PAYMENT_MODIFICATION]: {
            icon: PaymentCorrectionIcon({ color: colorToUse }),
            labelText: 'payment-modification-icon',
            amountColor
        },
        [TransactionKind.VOUCHER_PAYMENT_REVERSAL]: {
            icon: PaymentCorrectionIcon({ color: colorToUse || colors.brown }),
            labelText: 'voucher_reversal_icon',
            amountColor
        },
        [TransactionKind.REIMBURSEMENT]: {
            icon: ReimbursementCoinsIcon(),
            labelText: 'reimbursement-icon',
            amountColor
        }
    }

    return transactionTypeSettings[type as keyof TransactionKindConfigType]
}
